export const Footer = () => (
  <div class="btn-block">
    <button class="btn btn-normal btn-success">Створити</button>
    <button class="btn btn-normal btn-nobg btn-red btn-success">Відміна</button>
  </div>
);
